import { Box, Container, Typography } from "@mui/material";

import { FooterHeader } from "./components/FooterHeader";
import { FooterNavigation } from "./components/FooterNavigation";
import useResponsive from "../../hooks/useResponsive";

export const DaveyFooter = () => {
  const { isXs, isSm } = useResponsive();
  const isMobile = isXs || isSm;

  return (
    <Box padding={"20px"} sx={{ background: "#2E2C2D" }}>
      <Container>
        {!isMobile ? (
          <>
            <FooterHeader />
            <FooterNavigation />
          </>
        ) : (
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
            <Typography color={"#a3a3a3"}>
              ©2024 Davey Water | All rights reserved
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};
